import { MenuTable } from './MenuTable'
import { createRestClient, RestSchemas } from '@/contexts/QueryProvider'
import { useGetSearchParam } from '@/hooks'

type MessagesLandingMenuItem = RestSchemas['Messages.Landing.MenuItem']

export function MenuBuilderPanel() {
  const appId = useGetSearchParam<number>('appId')
  const { getUiApiGetMenu } = createRestClient()

  const { data, isPending, isError } = getUiApiGetMenu.useQuery(
    {
      path: { applicationId: appId!, grouping: 'menu' },
    },
    { enabled: !!appId }
  )

  if (!appId) {
    return <div>No app ID</div>
  }

  if (isPending) {
    return <div>Loading...</div>
  }

  if (isError) {
    return <div>Error</div>
  }

  return (
    <div className="container mx-auto py-10">
      <h1 className="mb-6 text-2xl font-bold">Application Menu Builder</h1>
      <MenuTable data={(JSON.parse(data?.definition ?? '')?.items as MessagesLandingMenuItem[]) ?? []} />
    </div>
  )
}
